export const BulkPersonaImportStatus = {
    ROLE_RECOMMENDATION_IN_PROGRESS: 0,
    ROLE_RECOMMENDATION_SUCCEEDED: 1,
    IN_PROGRESS: 2,
    SUCCEEDED: 3,
    PARTIAL_SUCCESS: 4,
    FAILED: 5,
    CANCELLED: 6
}